// removed by extract-text-webpack-plugin
module.exports = {"component":"_19j2iF2Zf-654Znh6R8dtk","btn":"_6eHDAXOBcSh1hOcWV3XHP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ExperienceShopRegisterForm/ExperienceShopRegisterForm.scss
 ** module id = 965
 ** module chunks = 0
 **/